import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import Differentials from "../components/sections/Differentials";
import Gallery from "../components/sections/Gallery";
import Testimonials from "../components/sections/Testimonials";
import Appointment from "../components/sections/Appointment";
import Location from "../components/sections/Location";
import FAQ from "../components/sections/FAQ";
import CTA from "../components/sections/CTA";
import Footer from "../components/Footer";
import TestimonialForm from "../components/sections/TestimonialForm";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import CoursePreRegistration from "../components/sections/CoursePreRegistration";

export default function Home() {
  return (
    <div
      data-testid="home-page"
      className="relative min-h-screen overflow-hidden bg-transparent"
    >
      <Navbar />

        <main className="relative z-10">
        <Hero />
        <CoursePreRegistration />
        <About />
        <Services />
        <Differentials />
        <Gallery />

        <Testimonials />

        <TestimonialForm />

        <Appointment />

        <Location />
        <FAQ />
        <CTA />
      </main>

      <Footer />

      <FloatingWhatsApp />
    </div>
  );
}
